import { useStationsFinder } from '@app/core/stations/hooks/useStations';

/**
 * Resolves logo URL and display name for a station thumbnail placeholder.
 */
export function useStationThumbnailBrand(stationId: string) {
  const finder = useStationsFinder();
  const station = finder(stationId);

  return {
    logoUrl: station?.logoUrl ?? undefined,
    stationName: station?.name,
  };
}
